import React from 'react';

export const NavigationAnchor = ({ id }: any) => {
  return <a id={id} style={{ display: 'block' }} />;
};
